export default function clipLongId(value: string) {
  return value.split('-')[0]
}
